import defaults from 'superagent-defaults';

// Create a defaults context
let superagent = defaults();

// Setup some defaults
superagent.set('Accept', 'application/json').set('Content-type', 'application/json');

export default superagent;
